import { useTranslation } from "react-i18next";
import TextContainer from "components/htmlElements/Text";
import React from "react";

type announcmentProps = {
  suggestedPolicy: string;
};
const RenderPayAttentionToPolicyAnnouncment = ({
  suggestedPolicy,
}: announcmentProps) => {
  const { t } = useTranslation();
  return (
    <TextContainer type="span">
      {t("payAttentionToPolicy")}

      <TextContainer type="span" bold>
        {suggestedPolicy && <span>:&nbsp;</span>}
        {suggestedPolicy}
      </TextContainer>
    </TextContainer>
  );
};

export default RenderPayAttentionToPolicyAnnouncment;
